// What this client's plan turns on, and how their POS looks. Kept on the device so the register still shows the right buttons offline.
import { useEffect, useState } from 'react';
import { FEATURE_CODES } from '@njpos/core';
import { api, loadSession } from './api';

interface Access { features: string[]; branding: { appName?: string; accent?: string } }
const KEY = 'njpos.access';
const ALL: Access = { features: FEATURE_CODES, branding: {} };

function cached(): Access {
  try { const a = JSON.parse(localStorage.getItem(KEY) ?? 'null'); if (a && Array.isArray(a.features) && a.userId === loadSession()?.user.id) return a; } catch { /* use the default */ }
  return ALL;
}

/** Paint the client's own main color over the green. */
export function applyBranding(b: Access['branding']) {
  const root = document.documentElement.style;
  if (b.accent && /^#[0-9a-fA-F]{6}$/.test(b.accent)) {
    root.setProperty('--green-800', b.accent);
    root.setProperty('--green-900', `color-mix(in srgb, ${b.accent} 55%, black)`);
    root.setProperty('--green-700', `color-mix(in srgb, ${b.accent} 80%, white)`);
    root.setProperty('--accent', b.accent);
  } else for (const k of ['--green-800', '--green-900', '--green-700', '--accent']) root.removeProperty(k);
}

export function useAccess() {
  const [a, setA] = useState<Access>(cached);
  useEffect(() => {
    const s = loadSession();
    if (!s || s.user.role === 'platform_admin') return;
    api<any>('/api/me').then((me) => {
      const next = { features: me.features ?? FEATURE_CODES, branding: me.branding ?? {} };
      try { localStorage.setItem(KEY, JSON.stringify({ ...next, userId: s.user.id })); } catch { /* storage blocked */ }
      setA(next);
    }).catch(() => {});
  }, [loadSession()?.user.id]);   // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { applyBranding(a.branding); }, [a.branding]);
  return { has: (code: string) => a.features.includes(code), appName: a.branding.appName || 'PourPoint.AI' };
}
